import { rankWith, uiTypeIs } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { FieldProps, WithDynamicFormContext } from '../WithDynamicFormContext';
import { InfoIcon } from "../../../../../icons/truWeb-icons";
import './style.scss';

const InfoControl = (props: FieldProps) => {
  const classes = props.uischema?.options?.classes;
  const hasIcon = props.uischema?.options?.hasIcon;
  
  return (
        <div className={`info-schema ${classes}`}>
          {
            hasIcon ? 
              <>
                <span className='infoIcon'> 
                  <InfoIcon fill="#008cc0" /> 
                </span> 
                {props.label}
              </> : 
              <>
                {props.label}
              </>
          }

        </div>
  );
};

export const InfoControlEntry = {
  tester: rankWith(1, uiTypeIs('InfoControl')),
  renderer: withJsonFormsControlProps(WithDynamicFormContext(InfoControl)),
};
